<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title>
            <span class="text-subtitle-1">Panel de productividad</span>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-2"
              small
              dark
              color="blue-grey"
              tile
              @click="abrirCatalogoUnidades"
            >
              <v-icon left small>mdi-format-list-bulleted</v-icon>
              Unidades
            </v-btn>
            <v-btn
              class="mr-2"
              small
              dark
              color="green"
              tile
              :loading="exportandoExcel"
              @click="exportarExcel"
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>
            <v-btn color="primary" dark small tile @click="initialize">
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  :items="puestos"
                  v-model="puesto_seleccionado"
                  label="Puesto"
                  clearable
                  filled
                  dense
                  item-text="puesto"
                  item-value="idpuesto"
                  single-line
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  label="Plantel"
                  filled
                  dense
                  hide-details
                  v-model="plantel"
                  :items="planteles"
                  item-text="plantel"
                  item-value="id_plantel"
                  clearable
                  single-line
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" lg="5">
                <v-text-field
                  label="Buscar"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                  single-line
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-data-table
              class="elevation-0 mt-4"
              :headers="headers"
              :items="trabajadorERP"
              :search="search"
              :loading="cargar"
              loading-text="Cargando trabajadores..."
              dense
              item-key="id_trabajador"
              :mobile-breakpoint="100"
              :footer-props="{ 'items-per-page-options': [15, 30, 50, -1] }"
            >
              <template v-slot:item.meta="{ item }">
                <span>{{ item.meta || '—' }}</span>
              </template>
              <template v-slot:item.actual="{ item }">
                <span>{{ item.actual || '—' }}</span>
              </template>
              <template v-slot:item.unidad="{ item }">
                <span>{{ item.unidad || '—' }}</span>
              </template>
              <template v-slot:item.sueldo_depositado="{ item }">
                <span>{{ item.sueldo_depositado || '—' }}</span>
              </template>
              <template v-slot:item.valor_comercial_aportado="{ item }">
                <span>{{ item.valor_comercial_aportado || '—' }}</span>
              </template>
              <template v-slot:item.rol_colaborador="{ item }">
                <span>{{ item.rol_colaborador || '—' }}</span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogUnidades" max-width="980px" scrollable>
      <v-card>
        <v-card-title class="text-subtitle-1">
          <v-icon left color="blue-grey">mdi-format-list-bulleted</v-icon>
          Catálogo de unidades por puesto
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogUnidades = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-row dense class="mb-2 align-end">
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="nuevaUnidadForm.id_puesto"
                :items="puestos"
                item-text="puesto"
                item-value="idpuesto"
                label="Puesto"
                filled
                dense
                hide-details
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="nuevaUnidadForm.id_plantel"
                :items="planteles"
                item-text="plantel"
                item-value="id_plantel"
                label="Sucursal"
                filled
                dense
                hide-details
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="nuevaUnidadForm.unidad"
                label="Unidad"
                filled
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="nuevaUnidadForm.meta_semana"
                label="Meta por semana"
                type="number"
                filled
                dense
                hide-details
                @keyup.enter="guardarNuevaUnidad"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="primary"
                small
                block
                depressed
                :loading="guardandoUnidad"
                @click="guardarNuevaUnidad"
              >
                Agregar
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headersUnidades"
            :items="unidades"
            dense
            hide-default-footer
            disable-pagination
            item-key="id"
            class="elevation-0"
          >
            <template v-slot:item.id_puesto="{ item }">
              <v-autocomplete
                v-model="item.id_puesto"
                :items="puestos"
                item-text="puesto"
                item-value="idpuesto"
                dense
                filled
                hide-details
                @change="actualizarUnidad(item)"
              ></v-autocomplete>
            </template>
            <template v-slot:item.id_plantel="{ item }">
              <v-autocomplete
                v-model="item.id_plantel"
                :items="planteles"
                item-text="plantel"
                item-value="id_plantel"
                dense
                filled
                hide-details
                @change="actualizarUnidad(item)"
              ></v-autocomplete>
            </template>
            <template v-slot:item.unidad="{ item }">
              <v-text-field
                v-model="item.unidad"
                dense
                hide-details
                filled
                @blur="actualizarUnidad(item)"
              ></v-text-field>
            </template>
            <template v-slot:item.meta_semana="{ item }">
              <v-text-field
                v-model="item.meta_semana"
                dense
                hide-details
                filled
                type="number"
                @blur="actualizarUnidad(item)"
              ></v-text-field>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn icon small color="error" @click="eliminarUnidad(item)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <div class="py-4 text-center grey--text">No hay unidades registradas</div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <carga v-if="cargar"></carga>
    <Alerta v-if="respuestaAlerta" :parametros="parametros"></Alerta>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import validarErrores from '@/mixins/validarErrores'
import funcionesExcel from '@/mixins/funcionesExcel'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
var XLSX = require('xlsx')

export default {
  name: 'PanelProductividad',
  components: { Alerta, carga },
  mixins: [validarErrores, funcionesExcel],
  data: function () {
    return {
      puesto_seleccionado: null,
      plantel: null,
      planteles: [],
      puestos: [],
      search: '',
      trabajadorERP: [],
      unidades: [],
      dialogUnidades: false,
      nuevaUnidadForm: {
        id_puesto: null,
        id_plantel: null,
        unidad: '',
        meta_semana: '',
      },
      guardandoUnidad: false,
      exportandoExcel: false,
      headersUnidades: [
        { text: 'Puesto', value: 'id_puesto' },
        { text: 'Sucursal', value: 'id_plantel' },
        { text: 'Unidad', value: 'unidad' },
        { text: 'Meta por semana', value: 'meta_semana', width: '150px' },
        { text: '', value: 'actions', sortable: false, width: '56px' },
      ],
      headers: [
        { text: 'ID', value: 'id_trabajador' },
        { text: 'Trabajador', value: 'nombre_completo' },
        { text: 'Puesto', value: 'puesto' },
        { text: 'Depto', value: 'departamento' },
        { text: 'Sucursal', value: 'plantel' },
        { text: 'Meta', value: 'meta', sortable: false, width: '120px' },
        { text: 'Actual', value: 'actual', sortable: false, width: '120px' },
        { text: 'Unidad', value: 'unidad', sortable: false, width: '160px' },
        { text: 'Sueldo depositado', value: 'sueldo_depositado', sortable: false, width: '150px' },
        { text: 'Valor comercial aportado', value: 'valor_comercial_aportado', sortable: false, width: '180px' },
        { text: 'Rol del colaborador', value: 'rol_colaborador', sortable: false, width: '160px' },
      ],
    }
  },
  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
  },
  watch: {
    puesto_seleccionado: function () {
      this.initialize()
    },
    plantel: function () {
      this.initialize()
    },
  },
  created: function () {
    var self = this
    self.cargar = true
    Promise.all([self.getPuestos(), self.getPlanteles(), self.initialize()])
      .catch(function () {})
      .finally(function () {
        self.cargar = false
      })
  },
  methods: {
    aplicarUnidades: function (lista) {
      this.unidades = Array.isArray(lista) ? lista : []
    },
    // ((valor económico generado - costo total del puesto) / costo total del puesto) * 100
    calcularRolColaborador: function (item) {
      if (!item) return '—'
      var valor = Number(
        String(item.valor_comercial_aportado == null ? '' : item.valor_comercial_aportado)
          .replace(/[,$%\s]/g, '')
          .replace(/—/g, '')
      )
      var costo = Number(
        String(item.sueldo_depositado == null ? '' : item.sueldo_depositado)
          .replace(/[,$%\s]/g, '')
          .replace(/—/g, '')
      )
      if (!isFinite(valor) || !isFinite(costo) || costo === 0) return '—'
      var pct = ((valor - costo) / costo) * 100
      if (!isFinite(pct)) return '—'
      return pct.toFixed(2) + '%'
    },
    initialize: function () {
      var self = this
      self.cargar = true
      var payload = {
        puesto_seleccionado: self.puesto_seleccionado,
        plantel: self.plantel,
      }
      return self.$http
        .post('panel.productividad.list', payload)
        .then(function (response) {
          var data = response.data || {}
          var rows = Array.isArray(data) ? data : data.trabajadores || []
          var unidades = Array.isArray(data) ? [] : data.unidades || []
          if (unidades.length || !Array.isArray(data)) {
            self.aplicarUnidades(unidades)
          }
          for (var i = 0; i < rows.length; i++) {
            rows[i].meta = rows[i].meta || '—'
            rows[i].unidad = rows[i].unidad || '—'
            rows[i].actual = rows[i].actual != null && rows[i].actual !== '' ? rows[i].actual : '—'
            rows[i].sueldo_depositado = rows[i].sueldo_depositado || '—'
            rows[i].valor_comercial_aportado = rows[i].valor_comercial_aportado || '—'
            rows[i].rol_colaborador = self.calcularRolColaborador(rows[i])
          }
          self.trabajadorERP = rows
        })
        .catch(function (error) {
          var msg = 'No se pudieron cargar los trabajadores'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          self.validarError(msg)
        })
        .finally(function () {
          self.cargar = false
        })
    },
    cargarUnidades: function () {
      var self = this
      return self.$http
        .get('panel.productividad.unidades')
        .then(function (response) {
          self.aplicarUnidades(response.data || [])
        })
        .catch(function () {})
    },
    abrirCatalogoUnidades: function () {
      this.nuevaUnidadForm = {
        id_puesto: null,
        id_plantel: null,
        unidad: '',
        meta_semana: '',
      }
      this.dialogUnidades = true
      this.cargarUnidades()
    },
    guardarNuevaUnidad: function () {
      var self = this
      var idPuesto = self.nuevaUnidadForm.id_puesto
      var idPlantel = self.nuevaUnidadForm.id_plantel
      var unidad = (self.nuevaUnidadForm.unidad || '').trim()
      var metaSemana = (self.nuevaUnidadForm.meta_semana || '').toString().trim()
      if (!idPuesto) return self.validarError('Selecciona un puesto')
      if (!idPlantel) return self.validarError('Selecciona una sucursal')
      if (!unidad) return self.validarError('Escribe la unidad')
      if (!metaSemana) return self.validarError('Escribe la meta por semana')
      self.guardandoUnidad = true
      self.$http
        .post('panel.productividad.unidades.add', {
          id_puesto: idPuesto,
          id_plantel: idPlantel,
          unidad: unidad,
          meta_semana: metaSemana,
        })
        .then(function (response) {
          self.aplicarUnidades(response.data && response.data.unidades)
          self.nuevaUnidadForm = {
            id_puesto: null,
            id_plantel: null,
            unidad: '',
            meta_semana: '',
          }
          self.initialize()
        })
        .catch(function (error) {
          var msg = 'No se pudo agregar la unidad'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          self.validarError(msg)
        })
        .finally(function () {
          self.guardandoUnidad = false
        })
    },
    actualizarUnidad: function (item) {
      var self = this
      if (!item || !item.id) return
      var idPuesto = item.id_puesto
      var idPlantel = item.id_plantel
      var unidad = (item.unidad || '').trim()
      var metaSemana = (item.meta_semana || '').toString().trim()
      if (!idPuesto) return self.validarError('El puesto es requerido')
      if (!idPlantel) return self.validarError('La sucursal es requerida')
      if (!unidad) return self.validarError('La unidad no puede quedar vacía')
      if (!metaSemana) return self.validarError('La meta por semana no puede quedar vacía')
      self.$http
        .post('panel.productividad.unidades.update', {
          id: item.id,
          id_puesto: idPuesto,
          id_plantel: idPlantel,
          unidad: unidad,
          meta_semana: metaSemana,
        })
        .then(function (response) {
          self.aplicarUnidades(response.data && response.data.unidades)
          self.initialize()
        })
        .catch(function (error) {
          var msg = 'No se pudo actualizar la unidad'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          self.validarError(msg)
          self.cargarUnidades()
        })
    },
    eliminarUnidad: function (item) {
      var self = this
      if (!item || !item.id) return
      self.$http
        .post('panel.productividad.unidades.delete', { id: item.id })
        .then(function (response) {
          self.aplicarUnidades(response.data && response.data.unidades)
          self.initialize()
        })
        .catch(function (error) {
          var msg = 'No se pudo eliminar la unidad'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          self.validarError(msg)
        })
    },
    exportarExcel: function () {
      var self = this
      self.exportandoExcel = true

      var cargarCatalogo = self.$http
        .get('panel.productividad.unidades')
        .then(function (response) {
          var lista = response.data || []
          self.aplicarUnidades(lista)
          return lista
        })

      var cargarPuestos = self.puestos && self.puestos.length
        ? Promise.resolve(self.puestos)
        : self.$http.get('puestos.all').then(function (response) {
            self.puestos = response.data || []
            return self.puestos
          })

      Promise.all([cargarPuestos, cargarCatalogo])
        .then(function (resultados) {
          var puestos = resultados[0] || []
          var unidades = resultados[1] || []
          var puestoById = {}
          var porDepto = {}
          var puestosConCatalogo = {}

          function nombreDepto(valor) {
            var d = valor == null ? '' : String(valor).trim()
            return d || 'SIN DEPARTAMENTO'
          }

          function asegurarDepto(depto) {
            if (!porDepto[depto]) porDepto[depto] = []
          }

          function slugDepto(depto) {
            return String(depto)
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .replace(/[^a-zA-Z0-9]+/g, '_')
              .replace(/^_+|_+$/g, '')
              .toUpperCase()
          }

          function hojaSegura(nombre) {
            var hoja = String(nombre || 'HOJA').substring(0, 31)
            if (!hoja) hoja = 'HOJA'
            return hoja
          }

          for (var i = 0; i < puestos.length; i++) {
            var p = puestos[i]
            var idP = p.idpuesto != null ? p.idpuesto : p.id_puesto
            if (idP == null) continue
            puestoById[String(idP)] = p
            asegurarDepto(nombreDepto(p.departamento))
          }

          for (var j = 0; j < unidades.length; j++) {
            var u = unidades[j]
            if (u.id_puesto == null) continue
            puestosConCatalogo[String(u.id_puesto)] = true
            var puestoCat = puestoById[String(u.id_puesto)]
            var deptoCat = nombreDepto(
              (puestoCat && puestoCat.departamento) || u.departamento
            )
            asegurarDepto(deptoCat)
            porDepto[deptoCat].push({
              Puesto: u.puesto || (puestoCat && puestoCat.puesto) || '',
              Unidad: u.unidad || '',
              Meta: u.meta_semana != null ? String(u.meta_semana) : '',
              Sucursal: u.plantel || '',
            })
          }

          for (var k = 0; k < puestos.length; k++) {
            var puesto = puestos[k]
            var idPuesto = puesto.idpuesto != null ? puesto.idpuesto : puesto.id_puesto
            if (idPuesto == null) continue
            if (puestosConCatalogo[String(idPuesto)]) continue
            var deptoPuesto = nombreDepto(puesto.departamento)
            asegurarDepto(deptoPuesto)
            porDepto[deptoPuesto].push({
              Puesto: puesto.puesto || '',
              Unidad: '',
              Meta: '',
              Sucursal: '',
            })
          }

          var deptos = Object.keys(porDepto).sort(function (a, b) {
            return String(a).localeCompare(String(b), 'es')
          })

          if (!deptos.length) {
            self.validarError('No hay puestos para exportar')
            return
          }

          // Un solo Excel: una hoja por departamento (nombre ≤ 31 chars)
          var workbook = XLSX.utils.book_new()
          var hojasUsadas = {}

          for (var d = 0; d < deptos.length; d++) {
            var nombre = deptos[d]
            var filas = porDepto[nombre].slice().sort(function (a, b) {
              var c1 = String(a.Puesto).localeCompare(String(b.Puesto), 'es')
              if (c1 !== 0) return c1
              return String(a.Sucursal).localeCompare(String(b.Sucursal), 'es')
            })
            var filasHoja = filas.map(function (f) {
              return {
                Puesto: f.Puesto || '',
                Unidad: f.Unidad || '',
                Meta: f.Meta || '',
                Sucursal: f.Sucursal || '',
              }
            })
            var hoja = hojaSegura(slugDepto(nombre) || 'DEPTO')
            // Evitar nombres de hoja duplicados tras truncar
            var base = hoja
            var n = 2
            while (hojasUsadas[hoja]) {
              var sufijo = '_' + n
              hoja = base.substring(0, 31 - sufijo.length) + sufijo
              n++
            }
            hojasUsadas[hoja] = true
            var sheet = XLSX.utils.json_to_sheet(filasHoja)
            XLSX.utils.book_append_sheet(workbook, sheet, hoja)
          }

          XLSX.writeFile(workbook, 'PANEL_PRODUCTIVIDAD_POR_DEPARTAMENTO.xls')

          self.validarSuccess(
            'Excel descargado con ' + deptos.length + ' hojas (una por departamento)'
          )
        })
        .catch(function (error) {
          var msg = 'No se pudo generar el Excel'
          if (error && error.message) msg = error.message
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          self.validarError(msg)
        })
        .finally(function () {
          self.exportandoExcel = false
        })
    },
    getPuestos: function () {
      var self = this
      return self.$http.get('puestos.all').then(function (response) {
        self.puestos = response.data || []
      })
    },
    getPlanteles: function () {
      var self = this
      return self.$http.get('planteles.activos').then(function (response) {
        self.planteles = (response.data || []).filter(function (el) {
          return [1, 2, 3, 4, '1', '2', '3', '4'].indexOf(el.estado) !== -1 || el.id_plantel == 13
        })
      })
    },
  },
}
</script>
